<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Header de bienvenida -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-welcome-card">
            <div class="card-header trainer-card-header">
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <h4 class="card-title trainer-title">
                    <i class="nc-icon nc-user-run"></i>
                    Bienvenido, Personal Trainer
                  </h4>
                  <p class="card-category trainer-subtitle">
                    Modo DEMO - Sistema de Gestión Personal Trainer
                  </p>
                </div>
                <div class="col-sm-6 text-right">
                  <div class="trainer-status-badge">
                    <span class="badge badge-success trainer-badge">
                      <i class="nc-icon nc-check-2"></i>
                      DEMO Activo
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cards de información rápida -->
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5 col-md-4">
                  <div class="icon-big text-center icon-warning trainer-icon">
                    <i class="nc-icon nc-single-02 text-success"></i>
                  </div>
                </div>
                <div class="col-7 col-md-8">
                  <div class="numbers">
                    <p class="card-category">Clientes Asignados</p>
                    <p class="card-title trainer-number">12</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer trainer-card-footer">
              <hr>
              <div class="stats">
                <i class="fa fa-refresh"></i>
                Actualizado ahora
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5 col-md-4">
                  <div class="icon-big text-center icon-warning trainer-icon">
                    <i class="nc-icon nc-calendar-60 text-info"></i>
                  </div>
                </div>
                <div class="col-7 col-md-8">
                  <div class="numbers">
                    <p class="card-category">Sesiones Hoy</p>
                    <p class="card-title trainer-number">8</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer trainer-card-footer">
              <hr>
              <div class="stats">
                <i class="fa fa-calendar-o"></i>
                Próxima en 2h
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5 col-md-4">
                  <div class="icon-big text-center icon-warning trainer-icon">
                    <i class="nc-icon nc-money-coins text-primary"></i>
                  </div>
                </div>
                <div class="col-7 col-md-8">
                  <div class="numbers">
                    <p class="card-category">Ingresos Mes</p>
                    <p class="card-title trainer-number">$2,340</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer trainer-card-footer">
              <hr>
              <div class="stats">
                <i class="fa fa-clock-o"></i>
                +15% vs mes anterior
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5 col-md-4">
                  <div class="icon-big text-center icon-warning trainer-icon">
                    <i class="nc-icon nc-chart-bar-32 text-warning"></i>
                  </div>
                </div>
                <div class="col-7 col-md-8">
                  <div class="numbers">
                    <p class="card-category">Progreso Promedio</p>
                    <p class="card-title trainer-number">87%</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer trainer-card-footer">
              <hr>
              <div class="stats">
                <i class="fa fa-refresh"></i>
                Basado en métricas
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección de próximas funcionalidades -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-features-card">
            <div class="card-header trainer-card-header">
              <h4 class="card-title trainer-title">
                <i class="nc-icon nc-settings-gear-65"></i>
                Funcionalidades en Desarrollo
              </h4>
              <p class="card-category trainer-subtitle">
                Próximamente disponibles en tu dashboard
              </p>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="trainer-feature-item">
                    <div class="trainer-feature-icon">
                      <i class="nc-icon nc-single-02"></i>
                    </div>
                    <h5>Gestión de Clientes</h5>
                    <p class="text-muted">
                      Administra la información completa de tus clientes, historial y progreso.
                    </p>
                    <div class="trainer-feature-status">
                      <span class="badge badge-warning">En desarrollo</span>
                    </div>
                  </div>
                </div>
                
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="trainer-feature-item">
                    <div class="trainer-feature-icon">
                      <i class="nc-icon nc-calendar-60"></i>
                    </div>
                    <h5>Calendario de Sesiones</h5>
                    <p class="text-muted">
                      Programa y gestiona todas tus sesiones de entrenamiento de forma visual.
                    </p>
                    <div class="trainer-feature-status">
                      <span class="badge badge-warning">En desarrollo</span>
                    </div>
                  </div>
                </div>
                
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="trainer-feature-item">
                    <div class="trainer-feature-icon">
                      <i class="nc-icon nc-paper"></i>
                    </div>
                    <h5>Planes de Entrenamiento</h5>
                    <p class="text-muted">
                      Crea y asigna rutinas personalizadas para cada uno de tus clientes.
                    </p>
                    <div class="trainer-feature-status">
                      <span class="badge badge-warning">En desarrollo</span>
                    </div>
                  </div>
                </div>
                
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="trainer-feature-item">
                    <div class="trainer-feature-icon">
                      <i class="nc-icon nc-chart-pie-36"></i>
                    </div>
                    <h5>Métricas y Progreso</h5>
                    <p class="text-muted">
                      Visualiza el progreso de tus clientes con gráficos y estadísticas.
                    </p>
                    <div class="trainer-feature-status">
                      <span class="badge badge-warning">En desarrollo</span>
                    </div>
                  </div>
                </div>
                
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="trainer-feature-item">
                    <div class="trainer-feature-icon">
                      <i class="nc-icon nc-money-coins"></i>
                    </div>
                    <h5>Gestión de Pagos</h5>
                    <p class="text-muted">
                      Administra los pagos y facturación de tus servicios como trainer.
                    </p>
                    <div class="trainer-feature-status">
                      <span class="badge badge-warning">En desarrollo</span>
                    </div>
                  </div>
                </div>
                
                <div class="col-lg-4 col-md-6 mb-4">
                  <div class="trainer-feature-item">
                    <div class="trainer-feature-icon">
                      <i class="nc-icon nc-chat-33"></i>
                    </div>
                    <h5>Comunicación</h5>
                    <p class="text-muted">
                      Mantén comunicación directa con tus clientes y envía recordatorios.
                    </p>
                    <div class="trainer-feature-status">
                      <span class="badge badge-warning">En desarrollo</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Información del modo DEMO -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-demo-info">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-md-8">
                  <h5 class="trainer-demo-title">
                    <i class="nc-icon nc-bulb-63"></i>
                    Modo DEMO - Personal Trainer
                  </h5>
                  <p class="trainer-demo-text">
                    Estás utilizando la versión DEMO del sistema para Personal Trainers. 
                    Este modo te permite explorar las funcionalidades que estarán disponibles 
                    próximamente. Los datos mostrados son únicamente para demostración.
                  </p>
                </div>
                <div class="col-md-4 text-right">
                  <button class="btn btn-outline-primary trainer-demo-btn" @click="showDemoInfo">
                    <i class="nc-icon nc-alert-circle-i"></i>
                    Más Información
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerDashboard',
  methods: {
    showDemoInfo() {
      this.$swal.fire({
        title: 'Modo DEMO - Personal Trainer',
        html: `
          <div style="text-align: left;">
            <h6><strong>¿Qué es el modo DEMO?</strong></h6>
            <p>Es una versión de prueba que te permite explorar las funcionalidades que tendrá el sistema para Personal Trainers.</p>
            
            <h6><strong>Funcionalidades actuales:</strong></h6>
            <ul>
              <li>Dashboard con métricas simuladas</li>
              <li>Vista previa de funcionalidades en desarrollo</li>
              <li>Interfaz personalizada con colores del brand</li>
            </ul>
            
            <h6><strong>Próximamente:</strong></h6>
            <ul>
              <li>Gestión completa de clientes</li>
              <li>Calendario de sesiones</li>
              <li>Creación de planes de entrenamiento</li>
              <li>Métricas y progreso detallado</li>
              <li>Y mucho más...</li>
            </ul>
          </div>
        `,
        icon: 'info',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#9ACD32',
        width: '600px'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
/* Variables de color del tema trainer */
.content {
  --trainer-primary: #9ACD32;    /* Verde lima principal */
  --trainer-secondary: #7CB342;  /* Verde más oscuro */
  --trainer-accent: #8BC34A;     /* Verde intermedio */
  --trainer-dark: #689F38;       /* Verde oscuro */
  --trainer-light: #DCEDC8;      /* Verde muy claro */
  --trainer-bg: #F1F8E9;         /* Fondo muy suave */
}

/* Cards de bienvenida */
.trainer-welcome-card {
  background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-secondary));
  color: white;
  border: none;
  box-shadow: 0 4px 20px 0px rgba(154, 205, 50, 0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
  
  .trainer-card-header {
    background: transparent;
    border-bottom: 1px solid rgba(255,255,255,0.2);
  }
  
  .trainer-title {
    color: white;
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
    }
  }
  
  .trainer-subtitle {
    color: rgba(255,255,255,0.8);
    margin-bottom: 0;
  }
  
  .trainer-status-badge {
    .trainer-badge {
      background: rgba(255,255,255,0.2);
      color: white;
      padding: 8px 16px;
      font-size: 12px;
      border-radius: 20px;
      
      i {
        margin-right: 5px;
      }
    }
  }
}

/* Cards de estadísticas */
.trainer-stats-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 25px 0 rgba(0,0,0,0.15);
    transform: translateY(-2px);
  }
  
  .trainer-icon {
    i {
      font-size: 32px;
    }
  }
  
  .trainer-number {
    font-size: 24px;
    font-weight: 700;
    color: var(--trainer-dark);
  }
  
  .trainer-card-footer {
    background: var(--trainer-bg);
    
    .stats {
      color: var(--trainer-secondary);
      font-size: 12px;
    }
  }
}

/* Card de funcionalidades */
.trainer-features-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  
  .trainer-card-header {
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    border-bottom: 1px solid #dee2e6;
  }
  
  .trainer-title {
    color: var(--trainer-dark);
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
      color: var(--trainer-primary);
    }
  }
  
  .trainer-subtitle {
    color: #6c757d;
    margin-bottom: 0;
  }
}

/* Items de funcionalidades */
.trainer-feature-item {
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  background: white;
  border: 2px solid var(--trainer-light);
  transition: all 0.3s ease;
  height: 100%;
  
  &:hover {
    border-color: var(--trainer-primary);
    box-shadow: 0 5px 15px rgba(154, 205, 50, 0.1);
    transform: translateY(-3px);
  }
  
  .trainer-feature-icon {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-accent));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 15px;
    
    i {
      font-size: 24px;
      color: white;
    }
  }
  
  h5 {
    color: var(--trainer-dark);
    font-weight: 600;
    margin-bottom: 10px;
  }
  
  p {
    font-size: 14px;
    margin-bottom: 15px;
  }
  
  .trainer-feature-status {
    .badge {
      padding: 5px 12px;
      font-size: 11px;
    }
  }
}

/* Card de información DEMO */
.trainer-demo-info {
  background: linear-gradient(135deg, #fff3cd, #ffeaa7);
  border: none;
  border-left: 4px solid var(--trainer-primary);
  
  .trainer-demo-title {
    color: var(--trainer-dark);
    font-weight: 600;
    margin-bottom: 10px;
    
    i {
      margin-right: 10px;
      color: #f39c12;
    }
  }
  
  .trainer-demo-text {
    color: #856404;
    margin-bottom: 0;
    line-height: 1.6;
  }
  
  .trainer-demo-btn {
    border-color: var(--trainer-primary);
    color: var(--trainer-primary);
    
    &:hover {
      background: var(--trainer-primary);
      color: white;
    }
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .trainer-feature-item {
    margin-bottom: 20px;
  }
  
  .trainer-demo-info .col-md-4 {
    text-align: center !important;
    margin-top: 15px;
  }
}
</style>